import * as React from 'react';

import {
  PaywallAction,
  PaywallState,
  usePaywallReducer,
} from './usePaywallReducer';

interface Context {
  state: PaywallState;
  dispatch: (action: PaywallAction) => void;
}

const PaywallContext = React.createContext<Context | undefined>(undefined);

type Props = { children: React.ReactNode };
export function PaywallProvider({ children }: Props) {
  const [state, dispatch] = usePaywallReducer();
  const value = { state, dispatch };

  return (
    <PaywallContext.Provider value={value}>{children}</PaywallContext.Provider>
  );
}

export function usePaywallContext() {
  const context = React.useContext(PaywallContext);

  if (context === undefined) {
    throw new Error('usePaywallContext must be used within a PaywallProvider');
  }

  return context;
}
